

const thisSwiper = new Swiper(".thisSwiper", {
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });